import React, { useRef, useState } from 'react';

import * as Yup from 'yup';
import FileSaver from 'file-saver';
import { toast } from 'react-hot-toast';
import ReactToPrint from 'react-to-print';
import { Button, DefaultInput } from 'ui-kit-takeat';
import {
  Divider,
  IconClose,
  IconPrinterFilled,
  Button as UiKitButton,
  IconMenuCircles,
  IconPencilFilled,
  IconDownload,
  Input as InputUI,
  Select as SelectUI,
  IconInfoFilled,
  IconPlus,
  Checkbox,
} from 'takeat-design-system-ui-kit';

import {
  Col,
  Modal,
  ModalBody,
  Row,
  Dropdown,
  DropdownToggle,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';

import { FaTrash } from 'react-icons/fa';
import PrintTermAccountDetails from '~/components/Prints/PrintTermAccountDetails';

import formatDate from '~/services/formatDate';
import { generateProductsSheet } from '~/services/SheetGenerate/generateCreditRegisterProductsSheet';
import { generateSheet } from '~/services/SheetGenerate/generateCreditRegisterSheet';
import getValidationErrors from '~/services/getValidationErrors';
import api from '~/services/api';

import { useAuth } from '~/context/AuthContext';
import formatCompleteDate from '~/services/formatCompleteDate';
import formatValue from '~/utils/formatValue';
import PrintBillDetails from '~/components/Prints/PrintBillsDetails';
import { DatePickerStyledUnify, DatePickerWrapper } from '../styles';
import {
  Container,
  TdStyled,
  DisplayNoneImprimir,
  DropdownItemStyled,
  StyledModal,
  TableArea,
  TableStyled,
  InputLine,
  InfoDiv,
  TotalBill,
  TitleHeader,
  NameContainer,
  NameAccount,
  TextNumberContainer,
  ArrowStyled,
  DropdownMn,
  BodyConsumption,
  InputTableStyled,
  Wrapper,
  ConsumerValue,
  HeaderForm,
  TitleSale,
  FormFields,
  FieldInput,
  BodyModal,
  TextTooltip,
  FooterModal,
  ToolTipModal,
  StyledModalCommand,
  ModalBodyy,
  TitleCheckbox,
  HeaderModalForm,
  QuitModal,
  Nfc,
} from './styles';
import { IoIosArrowDown } from 'react-icons/io';
import { Controller, useForm } from 'react-hook-form';
import { fetchDataToPrint } from '~/services/printer/dataToPrint';
import { printHtmlInIframe } from '~/services/printer/printerUtils';

function CreditRegisterItem({
  item,
  accountSelected,
  handleSelectAccount,
  registerCredits,
  setRegisterCredits,
  setTotalRegisterToReceive,
  getCreditRegisters,
  paymentMethodsOptions,
  banks,
}) {
  const { user } = useAuth();
  const [isModalEditAccountOpened, setIsModalEditAccountOpened] =
    useState(false);
  const [nfceArea, setNfceArea] = useState(false);

  function toggleModalEditAccount() {
    setIsModalEditAccountOpened(!isModalEditAccountOpened);
  }

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const [isPayoffModalOpened, setIsPayoffModalOpened] = useState(false);
  const togglePayoffModal = () => {
    setIsPayoffModalOpened(!isPayoffModalOpened);
    setVerifyDueDate(true);
    if (nfceArea === true) {
      setNfceArea(false);
    }
    resetQuitForm();
    setIsSubmiting(false);
  };
  const [expiresAt, setExpiresAt] = useState(
    item && item.expires_at ? new Date(item.expires_at) : null
  );
  const [dueDate, setDueDate] = useState();
  const [valueToPayOff, setValueToPayOff] = useState(0);
  const initialData = {
    name: item.name,
    cnpj: item.cnpj,
    phone: item.phone,
    total_limit: item.total_limit,
    expires_at: expiresAt,
  };

  const formRef = useRef(null);
  const payoffRef = useRef(null);

  const [verifyDueDate, setVerifyDueDate] = useState(true);
  const [localDestinoSelected, setLocalDestinoSelected] = useState('');

  const [responseNfce, setResponseNfce] = useState([]);

  const iframeRef = useRef(null);
  const handleFetchDataToPrint = async (payload) => {
    try {
      const htmlResponse = await fetchDataToPrint(payload);
      printHtmlInIframe(iframeRef, htmlResponse);
    } catch (error) {
      toast.error('Erro ao buscar dados para impressão');
    }
  };

  const {
    reset: resetQuitForm,
    handleSubmit: handleSubmitQuitForm,
    register: registerQuit,
    control: controlQuit,
    watch,
    formState: { errors: errorsQuit },
  } = useForm();
  const {
    reset: resetEditForm,
    handleSubmit: handleSubmitEdit,
    register: registerEdit,
    control: controlEdit,
    formState: { errors: errorsEdit },
  } = useForm({
    defaultValues: initialData,
  });

  async function handleSubmit(QuitData) {
    if (QuitData.total_limit && QuitData.total_limit < Math.abs(item.balance)) {
      toast.error('O valor do limite não pode ser menor do que o saldo devido');
    } else {
      try {
        const response = await api.put(
          `/restaurants/credit-register/${item.id}`,
          {
            name: QuitData.name,
            phone: QuitData.phone,
            cnpj: QuitData.cnpj,
            expires_at: expiresAt,
            total_limit: QuitData.total_limit || null,
          }
        );
        toast.success('Conta editada com sucesso');
        toggleModalEditAccount();

        const registers = [...registerCredits];

        const registerItemIndex = registers.findIndex(
          (reg) => reg.id === item.id
        );

        if (registerItemIndex !== -1) {
          const newUser = {
            ...response.data,
            credit_register_items: item.credit_register_items,
          };
          registers[registerItemIndex] = newUser;
        }

        setRegisterCredits(registers);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          if (formRef?.current) {
            formRef.current.setErrors(errors);
          }
        } else {
          toast.error('Erro ao editar conta');
        }
      }
    }
  }

  const [isSubmiting, setIsSubmiting] = useState(false);

  async function handleSubmitPayoff(QuitData) {
    setIsSubmiting(true);
    if (valueToPayOff > Math.abs(item.balance)) {
      toast.error('Favor inserir valor igual ao menor que o devedor');
      setIsSubmiting(false);
    } else if (valueToPayOff < Math.abs(item.balance)) {
      try {
        if (!dueDate) {
          setVerifyDueDate(false);
          setIsSubmiting(false);
        } else {
          const response = await api.post('/restaurants/credit-register/item', {
            value: QuitData.valuePayment,
            credit_register_id: item.id,
            due_date: dueDate,
            bank_account_id: QuitData.bank_account_id || null,
            cash_flow_payment_method_id:
              QuitData.cash_flow_payment_method_id || null,
          });
          setIsPayoffModalOpened(false);
          setNfceArea(false);
          toast.success('Valor inserido com sucesso!');

          const registers = [...registerCredits];

          const registerItemIndex = registers.findIndex(
            (reg) => reg.id === item.id
          );

          if (registerItemIndex !== -1) {
            registers[registerItemIndex] = response.data;
          }

          setRegisterCredits(registers);
          setTotalRegisterToReceive((oldValue) => {
            return oldValue - Number(QuitData.valuePayment);
          });
          setIsSubmiting(false);
        }
      } catch (error) {
        setIsSubmiting(false);

        // Erro relacionado à emissão da NFC-e
        if (error?.response?.data?.errorType === 'emit_nfce_issues') {
          setResponseNfce(error.response.data.payload);
        }
        // Qualquer outro erro
        toast.error(error?.response?.data?.message || 'Erro ao quitar valor');
      }
    } else if (nfceArea) {
      if (typeSelected === 'nfce') {
        // const dataSent = { key: data.session.key || session?.session_key };
        const dataSent = {};

        if (QuitData.email !== null && QuitData.email !== '') {
          dataSent.email = QuitData.email;
        }

        if (QuitData.cpf !== '' && QuitData.cpf !== null) {
          dataSent.cpf = QuitData.cpf;
        }

        if (QuitData.cnpj !== '' && QuitData.cnpj !== null) {
          dataSent.cnpj = QuitData.cnpj;
        }

        if (QuitData.infoAdittional) {
          dataSent.informacoes_adicionais_contribuinte =
            QuitData.infoAdittional;
        }

        dataSent.value = QuitData.valuePayment;
        dataSent.credit_register_id = item.id;
        dataSent.due_date = dueDate;
        dataSent.bank_account_id = QuitData.bank_account_id || null;
        dataSent.cash_flow_payment_method_id =
          QuitData.cash_flow_payment_method_id || null;
        dataSent.nfce_type = typeSelected;
        try {
          if (!dueDate) {
            setVerifyDueDate(false);
            setIsSubmiting(false);
          } else {
            const response = await api.post(
              `/restaurants/credit-register/finish`,
              dataSent
            );
            toast.success('Conta a prazo quitada');
            setNfceArea(false);
            setIsPayoffModalOpened(false);
            setTotalRegisterToReceive((oldValue) => {
              return oldValue - Number(QuitData.valuePayment);
            });

            const registers = [...registerCredits];

            const registerItemIndex = registers.findIndex(
              (reg) => reg.id === item.id
            );

            if (registerItemIndex !== -1) {
              registers[registerItemIndex].balance = 0;
              registers[registerItemIndex].credit_register_items = [];
            }

            setIsSubmiting(false);
            setRegisterCredits(registers);
            resetQuitForm();

            if (response.data.nfce.status_sefaz === '100') {
              window.open(
                `https://api.focusnfe.com.br${response.data.nfce.caminho_danfe}`,
                'janela',
                'width=795, height=590, top=100, left=699, scrollbars=no, status=no, toolbar=no, location=no, menubar=no, resizable=no, fullscreen=no'
              );
            }
          }
        } catch (error) {
          setIsSubmiting(false);

          if (error?.response?.data?.errorType === 'emit_nfce_issues') {
            setResponseNfce(error.response.data.payload);
          }

          if (error instanceof Yup.ValidationError) {
            const errors = getValidationErrors(error);
            if (payoffRef?.current) {
              payoffRef.current.setErrors(errors);
            }
          } else if (
            error.response.data.errorType === 'cashier_opening_not_found'
          ) {
            toast.error(
              'Não foi encontrado caixa em aberto. Favor abrir caixa para quitar a conta.'
            );
          } else {
            toast.error('Erro ao quitar valor');
            console.log(error.message);
          }
        }
      } else {
        const parsedData = {
          // key: data.session.key || session.session_key,
          cnpj: QuitData.cnpj,
          cpf: QuitData.cpf,
          nome_destinatario: QuitData.nome_destinatario,
          logradouro_destinatario: QuitData.logradouro_destinatario,
          numero_destinatario: QuitData.numero_destinatario,
          bairro_destinatario: QuitData.bairro_destinatario,
          municipio_destinatario: QuitData.municipio_destinatario,
          uf_destinatario: QuitData.uf_destinatario,
          indicador_inscricao_estadual_destinatario: ieSelected,
          local_destino: localDestinoSelected,
          informacoes_adicionais_contribuinte: QuitData.infoAdittional,
        };

        if (QuitData.inscricao_estadual_destinatario !== '') {
          parsedData.inscricao_estadual_destinatario =
            QuitData.inscricao_estadual_destinatario;
        }

        if (QuitData.email !== null && QuitData.email !== '') {
          parsedData.email = QuitData.email;
        }

        parsedData.value = QuitData.valuePayment;
        parsedData.credit_register_id = item.id;
        parsedData.due_date = dueDate;
        parsedData.bank_account_id = QuitData.bank_account_id || null;
        parsedData.cash_flow_payment_method_id =
          QuitData.cash_flow_payment_method_id || null;
        parsedData.nfce_type = typeSelected;
        try {
          if (!dueDate) {
            setVerifyDueDate(false);
            setIsSubmiting(false);
          } else {
            const response = await api.post(
              `/restaurants/credit-register/finish`,
              parsedData
            );
            toast.success('Conta a prazo quitada');
            setNfceArea(false);
            setTotalRegisterToReceive((oldValue) => {
              return oldValue - Number(QuitData.valuePayment);
            });
            setIsPayoffModalOpened(false);

            const registers = [...registerCredits];

            const registerItemIndex = registers.findIndex(
              (reg) => reg.id === item.id
            );

            if (registerItemIndex !== -1) {
              registers[registerItemIndex].balance = 0;
              registers[registerItemIndex].credit_register_items = [];
            }

            setIsSubmiting(false);
            setRegisterCredits(registers);
            resetQuitForm();

            if (response.data.nfce.status_sefaz === '100') {
              window.open(
                `https://api.focusnfe.com.br${response.data.nfce.caminho_danfe}`,
                'janela',
                'width=795, height=590, top=100, left=699, scrollbars=no, status=no, toolbar=no, location=no, menubar=no, resizable=no, fullscreen=no'
              );
            }
          }
        } catch (error) {
          setIsSubmiting(false);
          toast.error('Erro ao quitar conta');
        }
      }
    } else {
      try {
        if (!dueDate) {
          setVerifyDueDate(false);
          setIsSubmiting(false);
        } else {
          const response = await api.post(
            `/restaurants/credit-register/finish`,
            {
              value: QuitData.valuePayment,
              credit_register_id: item.id,
              due_date: dueDate,
              bank_account_id: QuitData.bank_account_id || null,
              cash_flow_payment_method_id:
                QuitData.cash_flow_payment_method_id || null,
              cpf: QuitData.cpf,
              cnpj: QuitData.cnpj,
              informacoes_adicionais_contribuinte:
                QuitData.informacoes_adicionais_contribuinte,
            }
          );
          toast.success('Conta a prazo quitada');
          setNfceArea(false);
          setTotalRegisterToReceive((oldValue) => {
            return oldValue - Number(QuitData.valuePayment);
          });
          setIsPayoffModalOpened(false);

          const registers = [...registerCredits];

          const registerItemIndex = registers.findIndex(
            (reg) => reg.id === item.id
          );

          if (registerItemIndex !== -1) {
            registers[registerItemIndex].balance = 0;
            registers[registerItemIndex].credit_register_items = [];
          }

          setRegisterCredits(registers);
          setIsSubmiting(false);
          resetQuitForm();
        }
      } catch (error) {
        setIsSubmiting(false);

        if (error?.response?.data?.errorType === 'emit_nfce_issues') {
          setResponseNfce(error.response.data.payload);
        }
        toast.error('Erro ao quitar conta');
      }
    }
  }

  // fiscal
  const [formData, setFormData] = useState({
    type: 'nfce',
    doc: 'cpf',
  });
  const [typeSelected, setTypeSelected] = useState('nfce');
  const [docSelected, setDocSelected] = useState('cpf');
  const [ieSelected, setIeSelected] = useState('9');
  const uf_options = [
    { label: 'Acre', value: 'AC' },
    { label: 'Alagoas', value: 'AL' },
    { label: 'Amapá', value: 'AP' },
    { label: 'Amazonas', value: 'AM' },
    { label: 'Bahia', value: 'BA' },
    { label: 'Ceará', value: 'CE' },
    { label: 'Distrito Federal', value: 'DF' },
    { label: 'Espírito Santo', value: 'ES' },
    { label: 'Goiás', value: 'GO' },
    { label: 'Maranhão', value: 'MA' },
    { label: 'Mato Grosso', value: 'MT' },
    { label: 'Mato Grosso do Sul', value: 'MS' },
    { label: 'Minas Gerais', value: 'MG' },
    { label: 'Pará', value: 'PA' },
    { label: 'Paraíba', value: 'PB' },
    { label: 'Paraná', value: 'PR' },
    { label: 'Pernambuco', value: 'PE' },
    { label: 'Piauí', value: 'PI' },
    { label: 'Rio de Janeiro', value: 'RJ' },
    { label: 'Rio Grande do Norte', value: 'RN' },
    { label: 'Rio Grande do Sul', value: 'RS' },
    { label: 'Rondônia', value: 'RO' },
    { label: 'Roraima', value: 'RR' },
    { label: 'Santa Catarina', value: 'SC' },
    { label: 'São Paulo', value: 'SP' },
    { label: 'Sergipe', value: 'SE' },
    { label: 'Tocantins', value: 'TO' },
  ];
  const type_options = [
    { value: 'nfce', label: 'NFCe (modelo 65)' },
    { value: 'nfe', label: 'NFe (modelo 55)' },
  ];

  const doc_options = [
    { value: 'cpf', label: 'CPF' },
    { value: 'cnpj', label: 'CNPJ' },
  ];

  const local_options = [
    { value: 1, label: 'Operação Interna' },
    { value: 2, label: 'Operação Interestadual' },
  ];

  const ie_options = [
    {
      value: '1',
      label: '1 – Contribuinte ICMS (informar a IE do destinatário);',
    },
    {
      value: '2',
      label:
        '2 – Contribuinte isento de Inscrição no cadastro de Contribuintes do ICMS;',
    },
    {
      value: '9',
      label:
        '9 – Não Contribuinte, que pode ou não possuir Inscrição Estadual no Cadastro de Contribuintes do ICMS.',
    },
  ];

  const componentRef = useRef(null);
  const componentBillRef = useRef(null);

  const handleDeleteCreditRegister = async () => {
    const confirm = window.confirm('Deseja realmente excluir essa conta?');
    if (confirm) {
      await api
        .delete(`/restaurants/credit-register/${item.id}`)
        .then((response) => {
          getCreditRegisters();
          toast.success('Conta excluída com sucesso');
        })
        .catch((error) => {
          toast.error('Erro ao excluir conta');
          console.log(error);
        });
    }
  };

  const [deleteModal, setDeleteModal] = useState(false);
  const [adminPassword, setAdminPassword] = useState('');
  const [creditItemId, setCreditItemId] = useState(null);
  const handleOpenCreditRegisterItemDeleteModal = (
    creditItemId,
    cashFlowId
  ) => {
    setDeleteModal(true);
    setCreditItemId(creditItemId);
  };
  const handleCloseCreditRegisterItemDeleteModal = () => {
    setDeleteModal(false);
    setCreditItemId(null);
    setAdminPassword('');
  };
  const handleDeleteCreditRegisterItem = async () => {
    if (adminPassword !== user.order_cancel_password) {
      toast.error('Senha administrativa incorreta');
      return;
    }
    await api
      .delete(`/restaurants/credit-register/item/${creditItemId}`)
      .then((response) => {
        toast.success('Pagamento excluído com sucesso');
        setDeleteModal(false);
        setCreditItemId(null);
        setAdminPassword('');
      })
      .catch((err) => {
        console.log('err', err);
        toast.error('Erro ao excluir pagamento');
      });
  };

  // baixar planilha detalhada
  const handleRegisterDownload = async (id) => {
    try {
      const response = await api.get(
        `/restaurants/credit-register/summary/${id}`
      );
      const sheet = await generateSheet(response.data);

      const uint = new Uint8Array(sheet);
      const blob = new Blob([uint], { type: 'application/excel' });

      FileSaver.saveAs(blob, `Contas-a-prazo-${item.name}.xlsx`);
    } catch (err) {
      console.log('Error download sheet > ', err);
    }
  };

  const handleProductsDownload = async (id) => {
    try {
      const response = await api.get(
        `/restaurants/credit-register/products/${id}`
      );
      const sheet = await generateProductsSheet(response.data);

      const uint = new Uint8Array(sheet);
      const blob = new Blob([uint], { type: 'application/excel' });

      FileSaver.saveAs(blob, `Produtos-Contas-a-prazo-${item.name}.xlsx`);
    } catch (err) {
      console.log('Error download sheet > ', err);
    }
  };

  const [isModalBillOpened, setISModalBillOpened] = useState(false);
  const [billState, setBillState] = useState(null);

  async function getBill(id) {
    try {
      const response = await api.get(
        `/restaurants/credit-register/session/${id}`
      );

      setBillState(response.data);
    } catch (error) {
      console.log(error);
    }
  }

  function toggleModalBill(id = null) {
    if (id) {
      getBill(id);
    }
    setISModalBillOpened(!isModalBillOpened);
  }

  function getTableName(table_number, table_type) {
    switch (table_type) {
      case 'delivery':
        return 'Delivery';
      case 'balcony':
        return 'Balcão';
      case 'table':
        return `Mesa ${table_number}`;
      default:
        return table_number;
    }
  }

  const movimentacaoIds = item.credit_register_items.map((mov) => mov.id);

  return (
    <>
      <iframe ref={iframeRef} style={{ display: 'none' }} />
      <Modal
        isOpen={deleteModal}
        toggle={handleCloseCreditRegisterItemDeleteModal}
        size="sm"
      >
        <div
          style={{
            width: '100%',
            padding: 20,
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'column',
            gap: 12,
          }}
        >
          <span>
            Digite a senha administrativa para excluir o pagamento. (O
            lancamento referente a este pagamento tambem sera excluido)
          </span>
          <DefaultInput
            title="Senha administrativa:"
            id="cancel_password"
            name="testing"
            type="password"
            autocomplete="new-password"
            value={adminPassword}
            onChange={(e) => setAdminPassword(e.target.value)}
          />
          <div style={{ display: 'flex', gap: 12 }}>
            <Button
              title="Fechar"
              onClick={handleCloseCreditRegisterItemDeleteModal}
            />
            <Button
              title="Excluir"
              buttonColor="#2ec9b7"
              onClick={handleDeleteCreditRegisterItem}
            />
          </div>
        </div>
      </Modal>

      <StyledModal
        $EditAccount
        isOpen={isModalEditAccountOpened}
        toggle={toggleModalEditAccount}
      >
        <HeaderForm>
          <TitleSale $titleModal>Editar conta</TitleSale>
          <IconClose
            color="#FF2C3A"
            onClick={toggleModalEditAccount}
            cursor="pointer"
          />
        </HeaderForm>
        <form onSubmit={handleSubmitEdit(handleSubmit)}>
          <ModalBodyy>
            <FormFields>
              <FieldInput>
                <InputUI
                  style={{ width: '100%' }}
                  label="Nome da conta "
                  name="name"
                  control={controlEdit}
                  register={registerEdit('name', {
                    required: 'Nome é obrigatório',
                  })}
                  error={errorsEdit.name?.message?.toString()}
                />
              </FieldInput>
              <FieldInput FieldInput md="5">
                <Controller
                  name="phone"
                  control={controlEdit}
                  rules={{
                    required: 'Número é obrigatório',
                  }}
                  render={({ field }) => (
                    <InputUI
                      {...field}
                      style={{ width: '100%' }}
                      placeholder="(xx) x xxxx-xxxx"
                      label="Telefone"
                      mask="(99) 99999-9999"
                      error={errorsEdit.phone?.message?.toString()}
                    />
                  )}
                />
              </FieldInput>
            </FormFields>
            <FormFields>
              <InputUI
                style={{ width: '100%' }}
                label="CPF/ CNPJ"
                name="cnpj"
                control={controlEdit}
                register={registerEdit('cnpj')}
              />
            </FormFields>
            <FormFields>
              <FieldInput md="6">
                <Controller
                  name="total_limit"
                  control={controlEdit}
                  defaultValue=""
                  render={({ field: { onChange, ...field } }) => (
                    <InputUI
                      isCurrency
                      label="Limite de Crédito"
                      {...field}
                      onChange={(e) => onChange(e.target.value)}
                    />
                  )}
                />
                <ToolTipModal>
                  <IconInfoFilled
                    id="tooltipOne"
                    fontSize={18}
                    fill={'#7A7A7A'}
                  ></IconInfoFilled>
                  <TextTooltip>
                    {' '}
                    Se vazio, o saldo não será limitado.
                  </TextTooltip>
                </ToolTipModal>
              </FieldInput>
              <FieldInput md="6">
                <TitleSale>Validade do saldo</TitleSale>
                <DatePickerStyledUnify
                  locale="pt"
                  name="expires_at"
                  selected={expiresAt}
                  dateFormat="dd/MM/yyyy"
                  onChange={(date) => setExpiresAt(date)}
                />
                <ToolTipModal>
                  <IconInfoFilled
                    id="tooltipOne"
                    fontSize={18}
                    fill={'#7A7A7A'}
                  ></IconInfoFilled>
                  <TextTooltip> Se vazio, não haverá data limite.</TextTooltip>
                </ToolTipModal>
              </FieldInput>
            </FormFields>
          </ModalBodyy>

          <FooterModal>
            <UiKitButton fontColor="#fff" customColor="#2ec9b7" type="submit">
              Salvar
            </UiKitButton>
          </FooterModal>
        </form>
      </StyledModal>

      <StyledModal isOpen={isPayoffModalOpened} toggle={togglePayoffModal}>
        <HeaderModalForm>
          <HeaderForm>
            <TitleSale $titleModal>Quitação</TitleSale>
            <IconClose
              color="#545454"
              fontSize={24}
              cursor="pointer"
              onClick={() => {
                togglePayoffModal();
                setNfceArea(false);
              }}
            />
          </HeaderForm>

          <form
            onSubmit={handleSubmitQuitForm(handleSubmitPayoff)}
            style={{ width: '100%' }}
          >
            <BodyModal>
              <QuitModal>
                <FormFields>
                  <FieldInput>
                    <TitleSale style={{ fontWeight: 'bold' }}>
                      Vencimento:
                    </TitleSale>
                    <DatePickerWrapper>
                      <DatePickerStyledUnify
                        locale="pt"
                        name="due_date"
                        selected={dueDate}
                        dateFormat="dd/MM/yyyy"
                        placeholderText="__/__/____"
                        onChange={(date) => setDueDate(date)}
                      />
                    </DatePickerWrapper>
                    {!verifyDueDate && (
                      <p style={{ color: '#FF2C3A' }}>Informar o vencimento</p>
                    )}
                  </FieldInput>
                  <FieldInput>
                    <InputUI
                      style={{ width: '100%' }}
                      isCurrency
                      label="Valor de Pagamento"
                      name="valuePayment"
                      control={controlQuit}
                      register={registerQuit('valuePayment', {
                        required: 'Valor de Pagamento é obrigatório',
                        onChange: (e) => setValueToPayOff(e.target.value),
                      })}
                      error={errorsQuit.valuePayment?.message?.toString()}
                    />
                  </FieldInput>
                </FormFields>
                <FormFields>
                  <FieldInput>
                    <Controller
                      name="cash_flow_payment_method_id"
                      control={controlQuit}
                      render={({ field }) => (
                        <SelectUI
                          {...field}
                          label="Forma de pagamento"
                          options={paymentMethodsOptions}
                          value={paymentMethodsOptions.find(
                            (option) => option.value === field.value
                          )}
                          onChange={(selectedOption) => {
                            field.onChange(selectedOption.value);
                          }}
                        />
                      )}
                    />
                  </FieldInput>
                  <FieldInput>
                    <Controller
                      name="bank_account_id"
                      control={controlQuit}
                      render={({ field }) => (
                        <SelectUI
                          {...field}
                          label="Conta Associada"
                          options={banks}
                          value={banks.find(
                            (option) => option.value === field.value
                          )}
                          onChange={(selectedOption) => {
                            field.onChange(selectedOption.value);
                          }}
                        />
                      )}
                    />
                  </FieldInput>
                </FormFields>
                <FormFields $tooltip>
                  <ToolTipModal>
                    <IconInfoFilled
                      id="tooltipOne"
                      fontSize={18}
                      fill={'#7A7A7A'}
                    />
                    <TextTooltip>
                      {' '}
                      Essa ação gera um “contas à receber”.
                    </TextTooltip>
                  </ToolTipModal>
                </FormFields>
                {Math.abs(parseFloat(valueToPayOff)).toString() ===
                  Math.abs(parseFloat(item.balance)).toString() &&
                  user.has_nfce &&
                  user.credit_register_with_nfce &&
                  !!watch('cash_flow_payment_method_id') && (
                    <FieldInput $buttonNfc>
                      <Checkbox
                        labelStyles={{ fill: '#545454' }}
                        name="is_nfce"
                        onChange={() => setNfceArea(!nfceArea)}
                      />
                      <TitleCheckbox>Emitir Nota Fiscal</TitleCheckbox>
                    </FieldInput>
                  )}
              </QuitModal>

              {user.has_nfce && nfceArea && (
                <Nfc>
                  <>
                    <FormFields>
                      <FieldInput>
                        <Controller
                          name="type"
                          control={controlQuit}
                          render={({ field }) => (
                            <SelectUI
                              {...field}
                              label="Tipo:"
                              options={type_options}
                              defaultValue={{
                                value: 'nfce',
                                label: 'NFCe (modelo 65)',
                              }}
                              onChange={(e) => {
                                setFormData({ ...formData, type: e.value });
                                if (e.value === 'nfe') {
                                  setDocSelected('cnpj');
                                } else {
                                  setDocSelected('cpf');
                                }
                                setTypeSelected(e.value);
                              }}
                            />
                          )}
                        />
                      </FieldInput>
                    </FormFields>
                    {typeSelected === 'nfce' && (
                      <>
                        <FormFields>
                          <FieldInput md="3">
                            <Controller
                              name="doc"
                              control={controlQuit}
                              render={({ field }) => (
                                <SelectUI
                                  {...field}
                                  label="Documento:"
                                  options={doc_options}
                                  defaultValue={{ value: 'cpf', label: 'CPF' }}
                                  value={doc_options.find(
                                    (option) => option.value === field.value
                                  )}
                                  onChange={(e) => {
                                    field.onChange(e.value);
                                    setFormData({ ...formData, doc: e.value });
                                    setDocSelected(e.value);
                                  }}
                                />
                              )}
                            />
                          </FieldInput>
                          <FieldInput md="9">
                            {docSelected === 'cpf' ? (
                              <Controller
                                name="cpf"
                                control={controlQuit}
                                render={({ field }) => (
                                  <InputUI
                                    {...field}
                                    label="CPF: (opcional)"
                                    placeholder="xxx.xxx.xxx-xx"
                                    mask="999.999.999-99"
                                  />
                                )}
                              />
                            ) : (
                              <Controller
                                name="cnpj"
                                control={controlQuit}
                                render={({ field }) => (
                                  <InputUI
                                    {...field}
                                    label="CNPJ: (opcional)"
                                    placeholder="xx.xxx.xxx/xxxx-xx"
                                    mask="99.999.999/9999-99"
                                  />
                                )}
                              />
                            )}
                          </FieldInput>
                        </FormFields>
                        <FormFields>
                          <FieldInput>
                            <Controller
                              name="informacoes_adicionais_contribuinte"
                              control={controlQuit}
                              render={({ field }) => (
                                <InputUI
                                  {...field}
                                  style={{ width: '100%' }}
                                  label="Informações Adicionais"
                                  placeholder=""
                                />
                              )}
                            ></Controller>
                          </FieldInput>
                        </FormFields>
                      </>
                    )}

                    {typeSelected === 'nfe' && (
                      <>
                        <FormFields>
                          <FieldInput>
                            <Controller
                              name="doc"
                              control={controlQuit}
                              render={({ field }) => (
                                <SelectUI
                                  name={field.name}
                                  label="Documento:"
                                  options={doc_options}
                                  defaultValue={{
                                    value: 'cnpj',
                                    label: 'CNPJ',
                                  }}
                                  value={doc_options.find(
                                    (option) => option.value === field.value
                                  )}
                                  onChange={(e) => {
                                    field.onChange(e.value);
                                    setFormData({ ...formData, doc: e.value });
                                    setDocSelected(e.value);
                                  }}
                                />
                              )}
                            />
                          </FieldInput>
                          {docSelected === 'cpf' ? (
                            <FieldInput md="9">
                              <Controller
                                name="cpf"
                                control={controlQuit}
                                render={({ field }) => (
                                  <InputUI
                                    {...field}
                                    label="CPF:"
                                    type="text"
                                    placeholder="xxx.xxx.xxx-xx"
                                    mask="999.999.999-99"
                                  />
                                )}
                              />
                            </FieldInput>
                          ) : (
                            <FieldInput md="9">
                              <Controller
                                name="cnpj"
                                control={controlQuit}
                                render={({ field }) => (
                                  <InputUI
                                    {...field}
                                    label="CNPJ:"
                                    type="text"
                                    placeholder="xx.xxx.xxx/xxxx-xx"
                                    mask="99.999.999/9999-99"
                                  />
                                )}
                              />
                            </FieldInput>
                          )}
                        </FormFields>
                        <FormFields>
                          <FieldInput>
                            <InputUI
                              label="Nome:"
                              name="nome_destinatario"
                              type="text"
                              placeholder=""
                              control={controlQuit}
                              register={registerQuit('nome_destinatario')}
                            />
                          </FieldInput>
                          <FieldInput>
                            <InputUI
                              label="Logradouro:"
                              name="logradouro_destinatario"
                              type="text"
                              placeholder=""
                              control={controlQuit}
                              register={registerQuit('logradouro_destinatario')}
                            />
                          </FieldInput>
                        </FormFields>
                        <FormFields>
                          <FieldInput md="3">
                            <InputUI
                              label="Número:"
                              name="numero_destinatario"
                              type="text"
                              placeholder=""
                              control={controlQuit}
                              register={registerQuit('numero_destinatario')}
                            />
                          </FieldInput>
                          <FieldInput md="6">
                            <InputUI
                              label="Bairro:"
                              name="bairro_destinatario"
                              type="text"
                              placeholder=""
                              control={controlQuit}
                              register={registerQuit('bairro_destinatario')}
                            />
                          </FieldInput>
                          <FieldInput md="3">
                            <Controller
                              name="uf_destinatario"
                              control={controlQuit}
                              render={({ field }) => (
                                <SelectUI
                                  {...field}
                                  label="UF:"
                                  placeholder="Estado"
                                  options={uf_options}
                                  value={uf_options.find(
                                    (option) => option.value === field.value
                                  )}
                                  onChange={(e) => {
                                    field.onChange(e.value);
                                    // setUfSelected(e.value);
                                  }}
                                />
                              )}
                            />
                            {/* <Input
                                    label="UF:"
                                    name="uf_destinatario"
                                    type="text"
                                    placeholder=""
                                    
                                    // value={initialData?.uf_destinatario && uf_options.filter(local => local.value === initialData?.uf_destinatario)}
                                    // onChange={(e) => setUfSelected(e.value)}
                                  /> */}
                          </FieldInput>
                        </FormFields>
                        <FormFields>
                          <FieldInput md="6">
                            <InputUI
                              label="Município:"
                              name="municipio_destinatario"
                              type="text"
                              placeholder=""
                              control={controlQuit}
                              register={registerQuit('municipio_destinatario')}
                            />
                          </FieldInput>
                          <FieldInput>
                            <Controller
                              name="local_destino"
                              control={controlQuit}
                              render={({
                                field: { value, onChange, ...field },
                              }) => (
                                <SelectUI
                                  {...field}
                                  label="Estado de origem:"
                                  options={local_options}
                                  // defaultValue={{
                                  //   value: 1,
                                  //   label: 'Operação Interna',
                                  // }}
                                  value={local_options.find(
                                    (option) => option.value === value
                                  )}
                                  onChange={(e) => {
                                    onChange(e.value);
                                    setLocalDestinoSelected(e.value);
                                  }}
                                />
                              )}
                            />
                          </FieldInput>
                        </FormFields>
                        <FormFields>
                          <FieldInput>
                            <Controller
                              name="indicador_inscricao_estadual_destinatario"
                              control={controlQuit}
                              render={({
                                field: { onChange, value, ...field },
                              }) => (
                                <SelectUI
                                  {...field}
                                  label="Indicador da Inscrição Estadual:"
                                  options={ie_options}
                                  // defaultValue={{
                                  //   value: '9',
                                  //   label:
                                  //     '9 – Não Contribuinte, que pode ou não possuir Inscrição Estadual no Cadastro de Contribuintes do ICMS.',
                                  // }}
                                  value={ie_options.find(
                                    (option) => option.value === value
                                  )}
                                  onChange={(e) => {
                                    onChange(e.value);
                                    setIeSelected(e.value);
                                  }}
                                />
                              )}
                            />
                          </FieldInput>

                          <FieldInput>
                            <InputUI
                              label={
                                ieSelected === '1'
                                  ? 'Inscrição Estadual: (obrigatório)'
                                  : 'Inscrição Estadual: (opcional)'
                              }
                              name="inscricao_estadual_destinatario"
                              type="text"
                              placeholder=""
                              control={controlQuit}
                              register={registerQuit(
                                'inscricao_estadual_destinatario'
                              )}
                            />
                          </FieldInput>
                        </FormFields>
                        <FormFields>
                          <FieldInput md="12">
                            <InputUI
                              style={{ width: '100%' }}
                              label="Informações Adicionais"
                              name="informacoes_adicionais_contribuinte"
                              type="text"
                              placeholder=""
                              control={controlQuit}
                              register={registerQuit(
                                'informacoes_adicionais_contribuinte'
                              )}
                            />
                          </FieldInput>
                        </FormFields>
                      </>
                    )}

                    <FormFields>
                      <FieldInput md="12">
                        <InputUI
                          style={{ width: '100%' }}
                          label="E-mail para enviar cópia da Nota Fiscal: (opcional)"
                          name="email"
                          type="email"
                          placeholder="exemplo@gmail.com"
                          control={controlQuit}
                          register={registerQuit('email')}
                        />
                      </FieldInput>
                    </FormFields>

                    <Row>
                      <Col md="12">
                        {responseNfce.mensagem_sefaz && (
                          <div style={{ marginTop: 10 }}>
                            {responseNfce.status_sefaz === '100' ||
                            responseNfce.status ===
                              'processando_autorizacao' ? (
                              <p>
                                <strong style={{ color: 'green' }}>
                                  {responseNfce.mensagem_sefaz}
                                </strong>
                              </p>
                            ) : (
                              <div>
                                <p>
                                  <strong style={{ color: 'red' }}>
                                    Mensagem SEFAZ:{' '}
                                    {responseNfce.response
                                      ? responseNfce.response.mensagem
                                      : responseNfce.mensagem_sefaz}
                                  </strong>
                                </p>
                                {typeSelected === 'nfe' &&
                                  responseNfce.response &&
                                  responseNfce.response.codigo ===
                                    'erro_validacao_schema' &&
                                  responseNfce.response.erros &&
                                  responseNfce.response.erros.map((erro) => (
                                    <p> - {erro.mensagem}</p>
                                  ))}
                                {responseNfce.response &&
                                  responseNfce.response.codigo ===
                                    'erro_validacao_schema' &&
                                  responseNfce.erros_schema &&
                                  responseNfce.erros_schema.map((e) => (
                                    <p>
                                      {' '}
                                      - <strong>{e.name}:</strong> {e.erro}
                                    </p>
                                  ))}
                              </div>
                            )}
                          </div>
                        )}
                      </Col>
                    </Row>
                  </>
                </Nfc>
              )}
            </BodyModal>

            <FooterModal>
              {nfceArea ? (
                <UiKitButton
                  fontColor="#fff"
                  isLoading={isSubmiting}
                  customColor="#FFB32F"
                  type="submit"
                  disabled={isSubmiting}
                  icon={<IconPlus fontSize={24} fill={' #ffff '} />}
                >
                  Emitir Nota Fiscal
                </UiKitButton>
              ) : (
                <UiKitButton
                  fontColor="#fff"
                  isLoading={isSubmiting}
                  customColor="#2ec9b7"
                  type="submit"
                  disabled={isSubmiting}
                >
                  Quitar
                </UiKitButton>
              )}
            </FooterModal>
          </form>
        </HeaderModalForm>
      </StyledModal>

      <StyledModalCommand isOpen={isModalBillOpened} toggle={toggleModalBill}>
        <ModalHeader
          style={{ justifyContent: 'space-between', display: 'flex' }}
        >
          <TitleHeader>Comanda</TitleHeader>
          <IconClose
            fill="#545454"
            onClick={toggleModalBill}
            style={{ width: 24, height: 24, cursor: 'pointer' }}
          />
        </ModalHeader>
        <ModalBody>
          <InputLine>
            <InfoDiv>
              <p>Data e Hora</p>
              <span>
                {billState ? formatCompleteDate(billState?.created_at) : '-'}
              </span>
            </InfoDiv>
            <InfoDiv>
              <p>Nº da Comanda</p>
              <span>{billState ? `# ${billState.id}` : '-'}</span>
            </InfoDiv>
            <InfoDiv>
              <p>Local de lançamento</p>
              <span>
                {billState &&
                  getTableName(
                    billState?.table?.table_number,
                    billState?.table?.table_type
                  )}
              </span>
            </InfoDiv>
          </InputLine>
          <TableArea>
            <TableStyled>
              <table>
                <thead>
                  <tr>
                    <th style={{ width: 138 }}>Quantidade</th>
                    <th style={{ width: 260 }}>Produto</th>
                    <th>Valor Unitário </th>
                    <th>Valor Consumido</th>
                  </tr>
                </thead>
                <tbody>
                  {billState?.bills?.map((bill) =>
                    bill.order_baskets.map((basket) =>
                      basket.orders.map((order) => (
                        <tr key={order.id}>
                          <td style={{ width: 138 }}>{order.amount}</td>
                          <td style={{ width: 260 }}>{order.product?.name}</td>
                          <td>
                            {formatValue(
                              (Number(order.price) || 0) +
                                (Number(order.complements_price) || 0)
                            )}
                          </td>
                          <td>{formatValue(order.total_service_price)}</td>
                        </tr>
                      ))
                    )
                  )}
                </tbody>
              </table>
            </TableStyled>
          </TableArea>
          <Divider style={{ marginTop: 8 }} />
        </ModalBody>

        <ModalFooter style={{ justifyContent: 'space-between' }}>
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <span
              style={{
                color: '#545454',
                fontWeight: 700,
                fontSize: 16,
              }}
            >
              Total da Comanda
            </span>
            <TotalBill style={{ marginLeft: 6 }}>
              {billState?.table?.table_type === 'delivery'
                ? formatValue(billState?.total_delivery_price)
                : formatValue(billState?.total_service_price)}
            </TotalBill>
          </span>
          <ReactToPrint
            trigger={() => (
              <UiKitButton customColor="#01AFFF" icon={<IconPrinterFilled />}>
                Imprimir
              </UiKitButton>
            )}
            content={() => componentBillRef.current}
          />
        </ModalFooter>
      </StyledModalCommand>

      <Container>
        <Wrapper>
          <TdStyled
            onClick={() => handleSelectAccount(item.id)}
            style={{ cursor: 'pointer' }}
          >
            <ArrowStyled>
              <IoIosArrowDown
                size={24}
                onClick={() => {
                  handleSelectAccount(item.id);
                }}
                style={{
                  transform: `rotate(${
                    accountSelected.includes(item.id) ? '-180deg' : '0deg'
                  })`,
                  transition: 'transform 0.3s ease',
                  cursor: 'pointer',
                }}
              />{' '}
            </ArrowStyled>
            <NameContainer>
              <NameAccount>{item.name}</NameAccount>
            </NameContainer>
          </TdStyled>

          <TdStyled>
            <TextNumberContainer>{item.phone}</TextNumberContainer>
          </TdStyled>

          <TdStyled>
            <TextNumberContainer>R$ {item.balance}</TextNumberContainer>
          </TdStyled>

          <TdStyled>
            <TextNumberContainer>
              {item.total_limit > 0 ? `R$ ${item.total_limit}` : '-'}
            </TextNumberContainer>
          </TdStyled>
          <TdStyled $buttonOptionsQuit>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                gap: '8px',
              }}
            >
              {item.balance >= 0 ? (
                <UiKitButton
                  style={{ width: 94, color: '#C6C6C6' }}
                  variant="default"
                  customColor="#EDEDED"
                >
                  PAGO
                </UiKitButton>
              ) : (
                <UiKitButton
                  style={{ width: 94 }}
                  variant="outlined"
                  customColor="#2EC9B7"
                  onClick={togglePayoffModal}
                >
                  {' '}
                  Quitar{' '}
                </UiKitButton>
              )}

              <Dropdown
                isOpen={dropdownOpen}
                toggle={() => setDropdownOpen((open) => !open)}
                direction="up"
              >
                <DropdownToggle tag="span" id="dropdown-mn">
                  {' '}
                  <IconMenuCircles
                    fontSize={24}
                    fill={'#222222'}
                    style={{ cursor: 'pointer' }}
                    id={`ellipsis2-${item?.id}`}
                  />
                </DropdownToggle>

                <DropdownMn anchor={`ellipsis2-${item?.id}`}>
                  <div
                    onClick={() => {
                      handleFetchDataToPrint({
                        print_type: 'credit_register',
                        credit_register_id: item.id,
                        credit_register_item_ids: movimentacaoIds,
                      });
                    }}
                  >
                    <DropdownItemStyled>
                      <IconPrinterFilled
                        color="#222222"
                        fontSize={20}
                        style={{ marginRight: 8 }}
                      />
                      Imprimir
                    </DropdownItemStyled>
                  </div>

                  <DropdownItemStyled onClick={() => toggleModalEditAccount()}>
                    <IconPencilFilled
                      color="#222222"
                      fontSize={20}
                      style={{ marginRight: 8 }}
                    />
                    Editar
                  </DropdownItemStyled>

                  {item.balance >= 0 && (
                    <DropdownItemStyled
                      onClick={() => handleDeleteCreditRegister()}
                    >
                      <FaTrash
                        color="#666666"
                        fontSize={16}
                        style={{ marginRight: 8 }}
                      />
                      Excluir
                    </DropdownItemStyled>
                  )}

                  <DropdownItemStyled
                    onClick={() => handleRegisterDownload(item?.id)}
                  >
                    <IconDownload
                      color="#666666"
                      fontSize={20}
                      style={{ marginRight: 8 }}
                    />
                    Baixar Histórico da Conta
                  </DropdownItemStyled>

                  <DropdownItemStyled
                    onClick={() => handleProductsDownload(item?.id)}
                  >
                    <IconDownload
                      color="#666666"
                      fontSize={20}
                      style={{ marginRight: 8 }}
                    />
                    Baixar Relatório de Produtos
                  </DropdownItemStyled>
                </DropdownMn>
              </Dropdown>
            </div>
          </TdStyled>
          <DisplayNoneImprimir>
            <PrintTermAccountDetails
              item={item}
              restaurant={user}
              ref={componentRef}
              // dates={{ initialDate, endDate }}
            />
          </DisplayNoneImprimir>

          {billState && (
            <DisplayNoneImprimir>
              <PrintBillDetails
                item={billState}
                restaurant={user}
                ref={componentBillRef}
                user={item}
              />
            </DisplayNoneImprimir>
          )}
        </Wrapper>

        <BodyConsumption isOpen={accountSelected.includes(item.id)}>
          <InputTableStyled>
            <thead>
              <tr>
                <th>Visitas: {item?.credit_register_items?.length || 0}</th>
                <th>Comanda</th>
                <th>Valor consumido</th>
                <th>Usuário</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {item &&
                item.credit_register_items?.length > 0 &&
                item.credit_register_items?.map((session) => (
                  <tr
                    isOpen={accountSelected.includes(item.id)}
                    key={session.id}
                    tag="tr"
                  >
                    <td style={{ border: 'none' }}>
                      {formatDate(session.createdAt)}
                    </td>
                    <td style={{ border: 'none', textAlign: 'center' }}>
                      {session.value > 0 ? (
                        `Pagamento`
                      ) : (
                        <UiKitButton
                          customColor="#EDEDED"
                          style={{
                            color: '#222',
                            width: 230,
                          }}
                          onClick={() => toggleModalBill(session.session_id)}
                        >
                          #{session.session_id}
                        </UiKitButton>
                      )}
                    </td>
                    <td style={{ display: 'flex', justifyContent: 'center' }}>
                      {session.value > 0 ? (
                        <ConsumerValue>R$ +{session.value}</ConsumerValue>
                      ) : (
                        <ConsumerValue $negative>
                          R$ {session.value}
                        </ConsumerValue>
                      )}
                    </td>
                    <td colSpan={1} style={{ border: 'none' }}>
                      {user.name || ''}
                    </td>

                    <td style={{ border: 'none' }}>
                      {session.cash_flow_id && (
                        <FaTrash
                          color="#FF2C3A"
                          size={18}
                          style={{ marginLeft: 8 }}
                          cursor="pointer"
                          onClick={() =>
                            handleOpenCreditRegisterItemDeleteModal(
                              session.id,
                              session.cash_flow_id
                            )
                          }
                        />
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </InputTableStyled>
        </BodyConsumption>
      </Container>
    </>
  );
}

export default CreditRegisterItem;